import { Outlet } from 'react-router-dom';
import LogoLoader from '../../components/Loading/LogoLoader';
import { useMemo } from 'react';
import { withAuthenticationRequired } from '../../auth/AppAuth';

export function AuthGuard() {
  const Component = useMemo(
    () =>
      withAuthenticationRequired(Outlet, {
        onRedirecting: () => <LogoLoader />,
      }),
    [],
  );

  return <Component />;
}
